export type BlogPressItem = {
  id: number;
  title: string;
  href: string;
  external: boolean;
};

export const blogPressData: BlogPressItem[] = [
  {
    id: 19,
    title:
      'Hera Flight Offers 25-Hour Jet Cards With One-Third Down Until Year-End',
    href: 'https://privatejetcardcomparisons.com/2026/10/22/hera-flight-offers-deal-until-end-of-year-on-25-hour-jet-cards-pending-doug-review/',
    external: true,
  },
  {
    id: 18,
    title: 'Hera Flight Citation X Fleet Expansion Press Release',
    href: '/hera-flight-citation-x-fleet-expansion-press-release',
    external: false,
  },
  {
    id: 17,
    title: 'Hera Flight Citation X Coverage',
    href: 'https://privatejetcardcomparisons.com/blog/citation-x/',
    external: true,
  },
  {
    id: 16,
    title:
      'Hera Flight Comments on Crypto Payments for Private Flights in Forbes',
    href: 'https://www.forbes.com/sites/douggollan/2026/08/05/can-kenny-dichters-real-jet-boost-crypto-payments-for-private-flights/',
    external: true,
  },
  {
    id: 15,
    title: 'Hera Flight Fleet Expansion 2026 Press Release',
    href: '/hera-flight-fleet-expansion-2026-press-release',
    external: false,
  },
  {
    id: 14,
    title: 'Hera Flight targets new flyers with 10-hour Jet Card launch',
    href: 'https://www.corporatejetinvestor.com/news/hera-flight/',
    external: true,
  },
  {
    id: 1,
    title: 'Hera Flight adds 10-hour jet cards',
    href: 'https://privatejetcardcomparisons.com/2026/05/18/hera-flight-adds-10-hour-jet-cards/',
    external: true,
  },
  {
    id: 2,
    title: '10 Hour JetCard Press Release',
    href: '/hera-10-hour-s-jet-program-press-release',
    external: false,
  },
  {
    id: 3,
    title: 'Why Palm Beachers Are Choosing Hera Flight',
    href: 'https://issuu.com/polamagazine/docs/pola_palm_beach_2026/s/153545236',
    external: true,
  },
  {
    id: 4,
    title: 'Hera Flight Comments on Jet Card Demand in Business Air News',
    href: 'https://www.businessairnews.com/mag_story.html?ident=36057',
    external: true,
  },
  {
    id: 5,
    title: 'Hera Flight Achieves WYVERN WINGMAN Operator Certification',
    href: 'https://www.wyvernltd.com/wyvern-press-room/hera-flight-achieves-wyvern-wingman-operator-certification/',
    external: true,
  },
  {
    id: 6,
    title: 'Hera Flight brings a trio of jets on board',
    href: 'https://www.businessairnews.com/mag_story.html?ident=34227&user=111842&PIN=275586',
    external: true,
  },
  {
    id: 7,
    title: 'Hera Flight in Business Air News',
    href: 'https://www.businessairnews.com/viewer/371/html5/index.html?pn=17',
    external: true,
  },
  {
    id: 8,
    title: 'Citation X brings speed and luxury to Hera fleet',
    href: 'https://www.businessairnews.com/mag_story.html?ident=32875',
    external: true,
  },
  {
    id: 9,
    title: 'Hera Flight adds to its Citation X fleet',
    href: 'https://privatejetcardcomparisons.com/2025/01/13/hera-flight-adds-to-its-citation-x-fleet/',
    external: true,
  },
  {
    id: 10,
    title: 'Pioneering A New Level of Advocacy in Private Air Charter',
    href: 'http://usprivateaviation.com/2023/10/06/pioneering-a-new-level-of-advocacy-in-private-air-charter/',
    external: true,
  },
  {
    id: 11,
    title: 'Is Private Jet Charter Demand Still High Post-Covid?',
    href: 'https://www.avbuyer.com/articles/private-jet-charter/is-private-jet-charter-demand-still-high-post-covid-113741',
    external: true,
  },
  {
    id: 12,
    title: 'Private Jet Card Comparisons Mentions our Jet Card Program!',
    href: 'https://privatejetcardcomparisons.com/2023/04/05/charter-operator-hera-flight-launches-jet-card-program/',
    external: true,
  },
];
